import {
  ADD_FROM_TWITTER_FAILURE,
  ADD_FROM_TWITTER_REQUESTED,
  ADD_FROM_TWITTER_SUCCESS,
} from 'actiontypes/contacts';
import ContactService from 'services/ContactService';

import fetchContacts from './fetchContacts';

const service = new ContactService();


/** ----------------------------------------------------------------------------
 * Add Friends from Twitter
 -----------------------------------------------------------------------------*/
export default function addFromTwitter() {
  return (dispatch) => {
    dispatch(addFromTwitterRequested());

    return service.addTwitterContacts()
      .then(({ data }) => {
        if (data.isSuccess || !('isSuccess' in data)) {
          dispatch(addFromTwitterSuccess(data));
          dispatch(fetchContacts());
          return data;
        }
        // If the API has failed to respect REST semantics and sent back a 200 with
        // an error message, then treat the response as an error
        return Promise.reject({ response: { data: { message: data.message } } });
      })
      .catch(error => dispatch(addFromTwitterFailure(error)));
  };
}

export const addFromTwitterRequested = () => ({
  type: ADD_FROM_TWITTER_REQUESTED,
  isAdding: true,
});

export const addFromTwitterSuccess = ({ isSuccess, message }) => ({
  type: ADD_FROM_TWITTER_SUCCESS,
  isSuccess,
  message,
  isAdding: false,
});

export const addFromTwitterFailure = error => ({
  type: ADD_FROM_TWITTER_FAILURE,
  isAdding: false,
  error: true,
  message: error && error.response.data.message,
  status: error.response && error.response.status,
});